const FORGOT_PASSWORD_LOGIN = 'FORGOT_PASSWORD_LOGIN';
const CHOOSE_METHODS_RECOVERY_PASS = 'CHOOSE_METHODS_RECOVERY_PASS';
const FORGOT_PASSWORD_PIN_EMAIL = 'FORGOT_PASSWORD_PIN_EMAIL';
const FORGOT_PASSWORD_VERIFY_PIN = 'FORGOT_PASSWORD_VERIFY_PIN';
const INSERT_NEW_PASSWORD = 'INSERT_NEW_PASSWORD';
const FORGOT_MDP_QUESTION_SCRT = 'FORGOT_MDP_QUESTION_SCRT';
// eslint-disable-next-line no-useless-escape
const STRONG_PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@#+=\$%\^&\*])(?=.{10,})/;

export {
  FORGOT_PASSWORD_LOGIN,
  CHOOSE_METHODS_RECOVERY_PASS,
  FORGOT_PASSWORD_PIN_EMAIL,
  FORGOT_PASSWORD_VERIFY_PIN,
  FORGOT_MDP_QUESTION_SCRT,
  INSERT_NEW_PASSWORD,
  STRONG_PASSWORD_REGEX,
};
